import { createGlobalStyle } from 'styled-components'
import { theme } from './theme'

export const DefaultSettings = createGlobalStyle`
  html, body, a {
    color: ${theme.darkGrey};
  }
  
  html {
    min-height: 100%;
    background-color: rgba(242,242,242,1);
  }
  
  body {
    font-family: ${theme.font.sanSerif};
    background: ${theme.backgroundColor};
  }
  
  p {
    padding: 0;
    margin: 0;
  }
  
  a, a * {
    cursor: pointer;
    outline: none !important;
  }
  
  a:hover, a:hover span {
    color: ${theme.accentMagenta};
    text-decoration: none;
    transition: color 0.2s;
  }
  
  ul {
    list-style: none;
    padding: 0;
  }
  
  pre {
    border-radius: 5px;
    font-size: 0.78em !important;
    box-shadow: ${theme.boxShadow};
  }
  
  [role=button] {
    outline: none;
  }
  
  .gatsby-image-wrapper {
    box-shadow: ${theme.boxShadow};
  }
`
